// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidemenu[data-v-22b423d6] {
  z-index: 950;
  box-shadow: 0 13px 15px 4px #a2a1a1;
  width: 400px;
  position: absolute;
  right: 14em;
  height: 600px;
}
.vehicle_input[data-v-22b423d6] {
  border-radius: 5px;
  border: 0px;
  width: 100%;
  height: 40px;
  padding: 0px 10px;
}
.autocomplete_vehicles[data-v-22b423d6] {
  height: 100%;
  background-color: #fff;
  z-index: 20;
  width: 100%;
}
.vehicles-dropdown[data-v-22b423d6] {
  width: 100%;
  list-style: none;
  margin: 0px;
  padding: 0px;
  height: 250px;
  overflow-y: auto;
}
.vehicles-dropdown li[data-v-22b423d6] {
  border-bottom: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}
.vehicles-dropdown li a[data-v-22b423d6] {
  padding: 10px;
  width: 100%;
  color: #555;
}
.autocomplete_vehicles[data-v-22b423d6]::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.autocomplete_vehicles[data-v-22b423d6]::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.vehicles-dropdown li a[data-v-22b423d6]:hover {
  text-decoration: none;
  background-color: #ddd;
}
.dropdown-image[data-v-22b423d6] {
  width: 55px;
  height: 40px;
}
.dropdown-text[data-v-22b423d6] {
  font-size: 12px;
  margin-left: 10px;
}
.search-icon[data-v-22b423d6] {
  position: absolute;
  top: 10px;
  right: 4px;
  padding: 3px;
  border-radius: 3px;
  color: #fff;
}
.next-heading[data-v-22b423d6] {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
}
.predictive-search[data-v-22b423d6] {
  position: fixed;
  overflow-y: auto;
  width: 200px !important;
  max-height: 200px !important;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SearchMenu/SearchMenu.vue"],"names":[],"mappings":";AA2DA;EACE,YAAY;EACZ,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;AACb;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,oDAAoD;AACtD;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;AACd","sourcesContent":["<template>\r\n  <div>\r\n    <div\r\n      class=\"h-100 search-banner-wrapper\"\r\n      style=\"background-color: #fff; padding: 8px 10px; border-radius: 5px\"\r\n    >\r\n      <div class=\"search-banner\" style=\"height: 100%; overflow-x: hidden; overflow-y: hidden\">\r\n        <div>\r\n          <div class=\"h-100\">\r\n            <div\r\n              class=\"next-heading mb-2 color-primary _text_color theme-text-color\"\r\n              :class=\"submenusearch ? 'd-none' : ''\"\r\n            >\r\n              Find your next...\r\n            </div>\r\n            <div class=\"row h-100\">\r\n              <div class=\"col-md-12 h-100\">\r\n                <div class=\"search-box h-100\" @click=\"searchBoxClickEvent($event)\">\r\n                  <input\r\n                    v-model=\"searchkey\"\r\n                    type=\"text\"\r\n                    name=\"\"\r\n                    class=\"search-input\"\r\n                    :placeholder=\"searchPlaceholderValue\"\r\n                    maxlength=\"50\"\r\n                    @input=\"searchVehicle()\"\r\n                    @keyup.enter=\"navigateToFirstVehicle()\"\r\n                  />\r\n                  <em\r\n                    class=\"primaryicon-search theme-bg-color\"\r\n                    :class=\"submenusearch ? '' : 'bgcolor-primary'\"\r\n                  ></em>\r\n                  <div\r\n                    class=\"autocomplete_vehicles\"\r\n                    :class=\"[overflowautocomplete ? 'predictive-search' : '']\"\r\n                    v-if=\"vehiclesdata.length\"\r\n                  >\r\n                    <ul class=\"vehicles-dropdown h-100\">\r\n                      <li\r\n                        ref=\"searchMenuVehicle\"\r\n                        v-for=\"(value, index) in vehiclesdata\"\r\n                        :key=\"index\"\r\n                        v-html=\"value\"\r\n                        @click=\"searchItemClick(index)\"\r\n                      ></li>\r\n                    </ul>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</template>\r\n<script src=\"./SearchMenu.js\" type=\"text/javascript\"></script>\r\n\r\n<style scoped>\r\n.sidemenu {\r\n  z-index: 950;\r\n  box-shadow: 0 13px 15px 4px #a2a1a1;\r\n  width: 400px;\r\n  position: absolute;\r\n  right: 14em;\r\n  height: 600px;\r\n}\r\n.vehicle_input {\r\n  border-radius: 5px;\r\n  border: 0px;\r\n  width: 100%;\r\n  height: 40px;\r\n  padding: 0px 10px;\r\n}\r\n\r\n.autocomplete_vehicles {\r\n  height: 100%;\r\n  background-color: #fff;\r\n  z-index: 20;\r\n  width: 100%;\r\n}\r\n\r\n.vehicles-dropdown {\r\n  width: 100%;\r\n  list-style: none;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  height: 250px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.vehicles-dropdown li {\r\n  border-bottom: 1px solid #e0e0e0;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.vehicles-dropdown li a {\r\n  padding: 10px;\r\n  width: 100%;\r\n  color: #555;\r\n}\r\n\r\n.autocomplete_vehicles::-webkit-scrollbar {\r\n  -webkit-appearance: none;\r\n  width: 7px;\r\n}\r\n\r\n.autocomplete_vehicles::-webkit-scrollbar-thumb {\r\n  border-radius: 4px;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.vehicles-dropdown li a:hover {\r\n  text-decoration: none;\r\n  background-color: #ddd;\r\n}\r\n\r\n.dropdown-image {\r\n  width: 55px;\r\n  height: 40px;\r\n}\r\n\r\n.dropdown-text {\r\n  font-size: 12px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.search-icon {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 4px;\r\n  padding: 3px;\r\n  border-radius: 3px;\r\n  color: #fff;\r\n}\r\n\r\n.next-heading {\r\n  text-align: center;\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n}\r\n\r\n.predictive-search {\r\n  position: fixed;\r\n  overflow-y: auto;\r\n  width: 200px !important;\r\n  max-height: 200px !important;\r\n  height: auto;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
